import { render, staticRenderFns } from "./ArtworkItem.vue?vue&type=template&id=35096e8c&scoped=true&"
import script from "./ArtworkItem.vue?vue&type=script&lang=js&"
export * from "./ArtworkItem.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkItem.vue?vue&type=style&index=0&id=35096e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35096e8c",
  null
  
)

export default component.exports